export const timeSessionDifference = () =>{
    
    const dateLogin = new Date(localStorage.getItem('timeSesion'));
    const dateNow = new Date();

   return (dateNow.getTime()-dateLogin.getTime())/60000;
}